export const PRODUCTS_REDUCER_NAME = 'products'
export const PRODUCT_ITEMS_REDUCER_NAME = 'items'
